window.ajaxCount = 0;
ACC.common = {
    currentPath: window.location.pathname,
    currentCurrency: "USD",
    $page: $("#page"),

    setCurrentCurrency: function () {
        ACC.common.currentCurrency = ACC.common.$page.data("currencyIsoCode");
    },

    refreshScreenReaderBuffer: function () {
        // changes a value in a hidden form field in order
        // to trigger a buffer update in a screen reader
        $('#accesibility_refreshScreenReaderBufferField').attr('value', new Date().getTime());
    },

    bindAll: function () {
        ACC.common.bindToUiCarouselLink();
        ACC.common.bindShowProcessingMessageToSubmitButton();
        ACC.common.moveHeaderTitle();
        ACC.common.bindCreateCartButton();
    },

    bindCreateCartButton: function () {
		$(document).on("click", ".js-disable-button-on-click", function (e) {

            var b = this;
            setTimeout(function () {
                b.disabled = true;
            }, 0);

        });
	},

    bindToUiCarouselLink: function () {
        $("ul.carousel > li a.popup").colorbox({
            onComplete: function () {
                ACC.common.refreshScreenReaderBuffer();
                $.colorbox.resize()
                ACC.product.initQuickviewLightbox();
            },

            onClosed: function () {
                ACC.common.refreshScreenReaderBuffer();
            }
        });
    },

    processingMessage: $("<img src='" + ACC.config.resource.spinner + "'/>"),

    bindShowProcessingMessageToSubmitButton: function () {

        $(':submit.show_processing_message').each(function () {
            $(this).on("click", ACC.common.showProcessingMessageAndBlockForm);
        });
    },

    showProcessingMessageAndBlockForm: function () {
        $(".js-checkout-content-panel").block({message: ACC.common.processingMessage});
    },

    blockFormAndShowProcessingMessage: function (submitButton) {
        var form = submitButton.parents('form:first');
        form.block({message: ACC.common.processingMessage});
    },

    showSpinner: function (message) {
        $('.spinner-wrapper').show();
        $('#spinnerMessage').html(message);
    },

    showSpinnerById: function (id) {
        $('#' + id).show();
    },

    hideSpinner: function () {
        $('.spinner-wrapper').hide();
        $('#spinnerMessage').html("");
    },

    hideSpinnerById: function (id) {
        $('#' + id).hide();
    },
    moveHeaderTitle: function () {
        var title = $('#content .header-title').detach();
        $('.header .headerContent').prepend(title);
    },
    waitForAjax: function (callback) {
        setTimeout(function () {
            if (window.ajaxCount != 0) {
                ACC.common.waitForAjax(callback);
            } else {
                callback();
            }
        }, 100);
    },
    // When a function would be called multiple times in a short time, this will only execute the last call, see
    // https://stackoverflow.com/questions/1909441/how-to-delay-the-keyup-handler-until-the-user-stops-typing
    delay: function delay(callback, ms) {
        var timer = 0;
        return function() {
            var context = this, args = arguments;
            clearTimeout(timer);
            timer = setTimeout(function () {
                callback.apply(context, args);
            }, ms || 0);
        };
    },
    generateThirdPartyAccessToken: function (event) {
        event.preventDefault();

        $.ajax({
            url: ACC.thirdPartyAccessTokenUrl + '?partnerId=' + $('#third-party-login-submit').attr('data-partnerId'),
            success: function (result) {
                $('#third-party-login-access-token').val(result);
                $('#third-party-login-form').submit();
            },
            async: false
        });
    },
    loginThirdParty: function () {
        $(".login-third-party").on("click", function () {
            event.preventDefault();

            // <tag class="X Y Z login-third-party smShop"></tag>
            // use last element of class as partnerId
            // data attributes are not shown when component is edited through smartedit
            var classes = $(this).attr('class').split(' ');
            var partnerId = classes[classes.length - 1]

            // get the query parameter, check if is not blank and login to search page
            var loginToSearchPage = false;
            var query = $(this).attr('data-query');
            if (query && !/^\s*$/.test(query)) {
                loginToSearchPage = true;
            }

            var endpointUrl = loginToSearchPage ? ACC.thirdPartySearchEndpointUrl : ACC.thirdPartyEndpointUrl;
            $.get(endpointUrl + '?partnerId=' + partnerId, function(endpoint){
                $.get(ACC.thirdPartyAccessTokenUrl + '?partnerId=' + partnerId, function(token){
                    if (loginToSearchPage) {
                        endpoint = endpoint + "&query=" + encodeURIComponent(query.trim());
                    }

                    $('<form>', {
                        'action': endpoint,
                        'method': 'POST',
                        'target': '_top'
                    }).append($('<input>', {
                        'name': 'access_token',
                        'value': token,
                        'type': 'hidden'
                    })).appendTo('body').submit();
                });
            });
        });
    },
    isInteger: function(value) {
        return /^\d+$/.test(value)
    },
    logout: function () {
        if (!KMVP.status.isLoggedIn) {
            ACC.common.deleteTokenFromLocalStorage();
            return;
        }
        $('.js-logout-clean').on('click', ACC.common.deleteTokenFromLocalStorage);
        ACC.common.setTimerForSpartacusLogout(KMVP.status.sessionTimeoutInMillis);
    },
    deleteTokenFromLocalStorage: function () {
        window.localStorage.setItem('spartacus⚿⚿auth', '{"token":{},"userId":"anonymous","redirectUrl":"postloginredirect"}');
        window.localStorage.removeItem('lastRequestInCurrentSession');
    },
    setLastRequestInCurrentSession:  function () {
        if (KMVP.status.isLoggedIn) {
            window.localStorage.setItem('lastRequestInCurrentSession', Date.now().toString());
        }
    },
    setTimerForSpartacusLogout: function (timeoutInMillis) {
        if (KMVP.status.isLoggedIn) {
            window.setTimeout(function () {
                var millisSinceLastRequest = Date.now() - parseInt(window.localStorage.getItem('lastRequestInCurrentSession'));
                if (millisSinceLastRequest < KMVP.status.sessionTimeoutInMillis) {
                    ACC.common.setTimerForSpartacusLogout(KMVP.status.sessionTimeoutInMillis - millisSinceLastRequest);
                    return;
                }
                ACC.common.deleteTokenFromLocalStorage();
            }, timeoutInMillis + 1000); // add one second buffer, because backend session timeout is only in seconds
        }
    },
    setupActiveCartForSpartacus: function () {
        window.localStorage.setItem(`spartacus⚿${KMVP.currentBaseSite}⚿cart`, `{"active":"${ACC.cart.currentKloecknerMerchantCartId}"}`);
    },
    setupAsmForSpartacus: function () {
        if (KMVP.status.asmEnabled) {
            window.localStorage.setItem('asm_enabled', true);
            var spartacus_asm = {"ui":{"collapsed":false},"tokenTarget":"User"};

            if (KMVP.token) {
                spartacus_asm.tokenTarget = "CSAgent";

                var spartacus_auth = {};
                spartacus_auth.token = KMVP.token;
                spartacus_auth.userId = KMVP.status.asmEmulatedCustomerUid === '' ? 'anonymous' : KMVP.status.asmEmulatedCustomerUid;
                window.localStorage.setItem('spartacus⚿⚿auth', JSON.stringify(spartacus_auth));
            }

            window.localStorage.setItem('spartacus⚿⚿asm', JSON.stringify(spartacus_asm));
        } else {
            window.localStorage.removeItem('asm_enabled');
            window.localStorage.removeItem('spartacus⚿⚿asm');
        }
    },
    showOrHideBetaToggle: function () {
        if (KMVP.status.betaRedirectConfigured && KMVP.status.redirectLoginToSpartacus) {
            $('.beta-toggle').removeClass('hide');
        } else {
            $('.beta-toggle').addClass('hide');
        }
    },
    addClearInputFunctionality: function () {
        // Should be hidden initially.
        $(".js-clearButton").hide();

        $(".js-clearButton").on("click", function (e) {
            var clearButton = $(this).filter('.icon-times');
            // Not visible.
            if (clearButton.length <= 0) {
                return;
            }

            var clearInput = clearButton.prev('.js-clearInput');

            clearButton.hide();

            var oldClearInputValue = clearInput.val();

            if (clearInput.val()) {
                clearInput.val("");
            }

            clearButton.trigger('kloeckner.clearButtonClicked', [oldClearInputValue]);
        });

        $(".js-clearInput").on("input", function (e) {
            var clearInput = $(this);
            var clearButton = clearInput.next('.js-clearButton');

            if (clearInput.val()) {
                // If class is not already set.
                clearButton.addClass("icon-times");
                clearButton.show();
            } else {
                clearButton.hide();
            }

            clearInput.trigger('kloeckner.clearInputTextChanged');
        });
    }, isElementInView: function (element, fullyInView) {
        if (!element) {
            return true;
        }

        var pageTop = $(window).scrollTop();
        var pageBottom = pageTop + $(window).height();
        var elementTop = $(element).offset().top;
        var elementBottom = elementTop + $(element).height();

        if (fullyInView === true) {
            return ((pageTop < elementTop) && (pageBottom > elementBottom));
        } else {
            return ((elementTop <= pageBottom) && (elementBottom >= pageTop));
        }
    }
};

$(document).ready(function () {
    ACC.common.setCurrentCurrency();
    ACC.common.bindAll();
    ACC.common.bindShowProcessingMessageToSubmitButton();
    ACC.common.loginThirdParty();
    ACC.common.logout();
    ACC.common.setLastRequestInCurrentSession();
    ACC.common.setupActiveCartForSpartacus();
    ACC.common.setupAsmForSpartacus();
    ACC.common.showOrHideBetaToggle();
    ACC.common.addClearInputFunctionality();
});

/* Extend jquery with a postJSON method */
jQuery.extend({
    postJSON: function (url, data, callback) {
        return jQuery.post(url, data, callback, "json");
    }
});

//add a CSRF request token to POST ajax request if its not available
$.ajaxPrefilter(function (options, originalOptions, jqXHR) {
    // Modify options, control originalOptions, store jqXHR, etc
    if (options.type === "post" || options.type === "POST") {
        var noData = (typeof(options.data) === "undefined" || options.data == null);
        if (noData) {
            options.data = "CSRFToken=" + ACC.config.CSRFToken;
        } else {
            var patt1 = /application\/json/i;
            if (options.data instanceof window.FormData) {
                options.data.append("CSRFToken", ACC.config.CSRFToken);
            }
            // if its a json post, then append CSRF to the header.
            else if (patt1.test(options.contentType)) {
                jqXHR.setRequestHeader('CSRFToken', ACC.config.CSRFToken);
            } else if (options.data.indexOf("CSRFToken") === -1) {
                options.data = options.data + "&" + "CSRFToken=" + ACC.config.CSRFToken;
            }
        }
    }

    // counting ajax requests
    window.ajaxCount++;
    jqXHR.done(function() {
        window.ajaxCount--;
        ACC.common.setLastRequestInCurrentSession();
    });
});

$.ajaxSetup({
    /**
     * Disabling ajax caching needed for solving problems with Internet Explorer
     */
    cache: false
});


